export default __webpack_public_path__ + "static/media/flag-saudi-active.def68b22.svg";